import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core';
import KatalMetricsPublisher from "@katal/metrics/lib/KatalMetricsPublisher";
import {AuthSession} from "@awsscm/awsscm-auth-manager/auth/type";
import {containsISO} from "../../helperMethods/FederatedIdentity";

export default class GqlDevClient {

    private katalMetricPublisher: KatalMetricsPublisher;
    private session: AuthSession | null;
    private authToken: string;
    private region: string;

    constructor(
        metricPublisher: KatalMetricsPublisher,
        authSession: AuthSession | null,
        token: string,
        region: string
    ) {
        this.katalMetricPublisher = metricPublisher;
        this.session = authSession;
        this.authToken = token;
        this.region = region;
    }

    fetch = (input: RequestInfo, init?: RequestInit) => {
        const fetchStartTime = new Date().valueOf();
        return fetch(input, init).then((response) => {
            if (!containsISO(this.region)) {
                this.katalMetricPublisher
                    .newChildActionPublisherForMethod('FetchTimeForGraphQl')
                    .publishCounterMonitor(
                        'FetchTimeForGraphQl',
                        new Date().valueOf() - fetchStartTime
                    );
            }
            return response;
        });
    }

    private client = () => {
        const uri = '/graphV2';
        return new ApolloClient({
            cache: new InMemoryCache({}),
            link: new HttpLink({
                uri,
                fetch: this.fetch
            }),
            queryDeduplication: false
        });
    };

    getClient = (): ApolloClient<any> => {
        return this.client();
    };
}